export default __webpack_public_path__ + "static/media/add-academic.ac24cf97.svg";